import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ContactFormPayload } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'contact',
    events: {
        'Submit Contact Form': props<{
            payload: ContactFormPayload;
            dealerSlug?: string;
            dealerName?: string;
            dealerId?: string;
        }>(),
        'Submit Contact Form Response': props<{ success: boolean }>(),
        'Submit Contact Form Loading': props<{ loading: boolean }>(),
        'Reset Contact Form': emptyProps(),
    },
});
